export const DEFAULT_LOGO_LOADER_SIZE_PX = 60;
export const BUTTON_LOADER_SIZE_PX = 24;
